import type { ShareOptions } from 'react-native-share'
import type { ShareOpenResult } from 'react-native-share/lib/typescript/types'

let nativeShare: typeof import('react-native-share') | undefined

try {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  nativeShare = require('react-native-share')
} catch {
  console.log('share not available')
}

export async function openShare(options: ShareOptions): Promise<ShareOpenResult> {
  if (!nativeShare) return { success: false, message: 'share not available' }

  return nativeShare.default.open(options)
}
